
















































import { Prop, Component, Watch, Vue } from "vue-property-decorator";
// @ts-ignore
import parseISO from "date-fns/parseISO";

import { ActionGuest } from "@/components/organisms/Table/blocks/RowPicker/blocks/TableRowList/cells";
import Counter from "@/components/pages/ProductPage/blocks/Counter/Counter.vue";

import { personalModule, pricesModule } from "@/plugins/store-accessors";
import { calcMarginPrice } from "@/services/utils";

@Component({
  name: "Prices",
  components: {
    Counter,
    ActionGuest,
  },
})
export default class Prices extends Vue {
  @Prop({ type: String, default: "0" })
  readonly price!: string;

  @Prop({ type: Number, default: null })
  readonly stock!: number;

  @Prop({ type: String, default: null })
  readonly promo_start!: string;

  @Prop({ type: String, default: null })
  readonly promo_end!: string;

  @Prop({ type: String, default: "0" })
  readonly promo_price!: string;

  @Prop({ type: Number, default: null })
  readonly promo_stock!: string;

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  get currentDataPrice() {
    return pricesModule.getCurrentData;
  }

  get getMarginPrice() {
    const dataPrice = this.currentDataPrice;
    if (dataPrice) {
      return calcMarginPrice(
        Number(this.price),
        dataPrice.margin,
        dataPrice.rounding,
      );
    }
    return Number(this.price);
  }

  get getMarginPromoPrice() {
    const dataPrice = this.currentDataPrice;
    if (dataPrice) {
      return calcMarginPrice(
        Number(this.promo_price),
        dataPrice.margin,
        dataPrice.rounding,
      );
    }
    return Number(this.promo_price);
  }

  get convertedPrice() {
    return this.getMarginPrice.toLocaleString();
  }

  get convertedPromoPrice() {
    return this.getMarginPromoPrice.toLocaleString();
  }

  get summDiscount() {
    if (this.getMarginPrice && this.getMarginPromoPrice) {
      return (
        parseFloat(this.getMarginPrice.toString()) -
        parseFloat(this.getMarginPromoPrice.toString())
      );
    }

    return 0;
  }

  get percentDiscount() {
    if (this.getMarginPrice && this.getMarginPromoPrice) {
      return Math.round(
        100 -
          (parseFloat(this.getMarginPromoPrice.toString()) /
            parseFloat(this.getMarginPrice.toString())) *
            100,
      );
    }

    return 0;
  }

  get startDiscountTimer() {
    try {
      const dateStartParse = parseISO(this.promo_start);
      const dateEndParse = parseISO(this.promo_end);
      const nowDate = new Date().getTime();
      const startDate = dateStartParse?.getTime();
      const endDate = dateEndParse?.getTime();
      return startDate < nowDate && endDate > nowDate && this.promo_price;
    } catch (error) {
      return false;
    }
  }

  get hidePrice() {
    return pricesModule.getHidePrice;
  }

  get startDiscountStock() {
    return this.promo_stock && this.promo_price;
  }

  get classes() {
    return {
      "product-price-promo": !!this.promo_price,
    };
  }

  showLoginModal() {
    return personalModule.showLoginModal();
  }
}
